<template>
  <el-dialog
    :title="$l('INDEX.btn_print_tag') || '标签打印'"
    :visible.sync="showPrintView"
    width="800px"
  >
    <el-form ref="printFormRef" direction="vertical" :model="detail">
      <el-descriptions :column="2" border size="">
        <el-descriptions-item
          label-class-name="print-view-label"
          content-class-name="print-view-content"
        >
          <template slot="label">
            {{ $l('INDEX.form_label_amzSkuNo') || '产品SKU编号' }}
          </template>
          {{ detail.amzSkuNo }}
        </el-descriptions-item>
        <el-descriptions-item
          label-class-name="print-view-label"
          content-class-name="print-view-content"
        >
          <template slot="label">
            {{ $l('INDEX.amz_sku_inv_query_ncNo') || 'NC编号' }}
          </template>
          <el-form-item prop="ncNo">
            {{ detail.ncNo }}
          </el-form-item>
        </el-descriptions-item>
        <el-descriptions-item
          label-class-name="print-view-label"
          content-class-name="print-view-content"
        >
          <template slot="label">
            {{ $l('INDEX.table_label_brandName') || '品牌' }}
          </template>
          {{ detail.brandName }}
        </el-descriptions-item>
        <el-descriptions-item
          label-class-name="print-view-label"
          content-class-name="print-view-content"
        >
          <template slot="label">
            {{ $l('form_label_collectionName') || '系列' }}
          </template>
          {{ detail.collectionName }}
        </el-descriptions-item>
        <el-descriptions-item span="2" label-class-name="print-view-label">
          <template slot="label">
            {{ $l('INDEX.form_label_goodsNameCn') || '中文名称' }}
          </template>
          {{ detail.goodsName }}
        </el-descriptions-item>
        <el-descriptions-item span="2" label-class-name="print-view-label">
          <template slot="label">
            {{ $l('INDEX.form_label_goodsNameEn') || '英文名称' }}
          </template>
          {{ detail.goodsNameEn }}
        </el-descriptions-item>
        <el-descriptions-item span="2" label-class-name="print-view-label">
          <template slot="label">
            {{ $l('INDEX.form_label_goodsSize') || '产品尺寸' }}
          </template>
          {{ detail.goodsSize }}
        </el-descriptions-item>
        <el-descriptions-item
          label-class-name="print-view-label"
          content-class-name="print-view-content"
        >
          <template slot="label">
            {{ $l('INDEX.form_label_goodsColor') || '颜色' }}
          </template>
          {{ detail.goodsColor }}
        </el-descriptions-item>
        <el-descriptions-item
          label-class-name="print-view-label"
          content-class-name="print-view-content"
        >
          <template slot="label">
            {{ $l('form_label_printNumber') || '打印数量' }}
          </template>
          <el-input-number
            v-model="detail.printNumber"
            controls-position="right"
            :min="1"
            :max="99999"
          >
          </el-input-number>
        </el-descriptions-item>
        <el-descriptions-item label-class-name="print-view-label">
          <template slot="label">
            {{ $l('INDEX.form_label_inCtnQty') || '装箱入数' }}
          </template>
          {{ detail.inCtnQty }}
        </el-descriptions-item>
      </el-descriptions>
    </el-form>
    <span slot="footer" class="dialog-footer">
      <el-button @click="showPrintView = false">取 消</el-button>
      <el-button type="primary" @click="print">打 印</el-button>
    </span>
  </el-dialog>
</template>
<script>
export default {
  data() {
    return {
      showPrintView: false,
      amzSkuNo: '',
      amzSkuCode: '',
      ncNo: '',
      inCtnQty: 0,
      ctnQty: 0,
      detail: {},
    }
  },
  methods: {
    getData() {
      this.$api
        .ecomAmzSkuDetailPrintViewApi({
          amzSkuCode: this.amzSkuCode,
        })
        .then((res) => {
          console.log(res.body)
          this.detail = res.body
          this.detail.ncNo = this.ncNo || res.body.ncNo
          this.detail.inCtnQty = this.inCtnQty || res.body.inCtnQty
          this.detail.ctnQty = this.ctnQty || res.body.ctnQty
        })
        .catch(() => {})
        .finally(() => {
          this.loading = false
        })
    },
    open(amzSkuCode, ncNo, inCtnQty, ctnQty) {
      this.amzSkuCode = amzSkuCode
      this.ncNo = ncNo
      this.inCtnQty = inCtnQty
      this.ctnQty = ctnQty
      this.showPrintView = true
      this.getData()
    },
    print() {
      let data = {
        amzSkuCode: this.amzSkuCode,
        ncNo: this.detail.ncNo,
        inCtnQty: this.detail.inCtnQty,
        printNumber: this.detail.printNumber,
      }
      let fileName = `出库通知单SKU标签_${this.detail.amzSkuNo}_${this.detail.ncNo}_入数${this.detail.inCtnQty}_${this.detail.printNumber}张`
      this.$api.globalExportData('/ecom/amz/sku/print', data, fileName)
    },
  },
}
</script>
<style lang="scss">
.print-view-label {
  width: 124px !important;
}
.print-view-content {
  width: 255px !important;
}
</style>
